import React, { useEffect, useState } from 'react';
import InputWrapper from '../../../../common/InputWrapper';
import Select from '../../../../common/Select';
import DatePicker from '../../../../common/DatePicker';
import moment from 'moment';
import Button from '../../../../common/Button';
import Table from '../../../../common/Table';
import SpinnerBlock from '../../../../common/SpinnerBlock';
import TextArea from './../../../../common/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetSkuQtyCorrection, fetchPostSkuQtyCorrection } from '../../../../../actions/admin';
import { toast } from 'react-toastify';
import { showModal } from '../../../../../actions/modal';
import { MOCK_DELIVERY_ITEM } from '../../../../../config';
import { useFormik } from 'formik';
import { CORRECTION_MODS } from '../../../../../config';
import * as Yup from 'yup';
import styled from '@emotion/styled';

const CORRECTION_TYPE_OPTIONS = [
  {
    label: 'Оприходование',
    value: 'ADD',
  },
  {
    label: 'Списание',
    value: 'SUBTRACT',
  },
];

const validationSchema = Yup.object().shape({
  correctionType: Yup.string().required('Укажите тип корректировки'),
  warehouseId: Yup.string().required('Укажите склад'),
});

const Wrapper = styled('div')`
  .text-center {
    width: 100%;
    text-align: center;
  }

  .table .thead-light th:nth-child(n + 2) {
    text-align: center !important;
  }

  .warehouse-children {
    margin-top: 8px;
  }
`;

const Correction = ({ handleSwitchMode, mode, correctionId = null }) => {
  const dispatch = useDispatch();

  const warehouses = useSelector((state) => state.orders.warehouses);

  const [skuCorrections, setSkuCorrections] = useState(null);
  const [products, setProducts] = useState([]);
  const [showSpinner, setShowSpinner] = useState(mode === CORRECTION_MODS.ADD ? false : true);

  const formik = useFormik({
    initialValues: {
      id: '',
      columnType: '',
      comment: '',
      correctionType: '',
      warehouseId: '',
      createTs: '',
    },
    onSubmit: async (values) => {
      await handleCreateCorrection(values);
    },
    enableReinitialze: true,
    validationSchema,
  });
  const { values, errors, submitCount, handleChange, handleSubmit, setFieldValue } = formik;

  const handleCreateCorrection = async () => {
    const updatedItems = products
      .filter((p) => p.variantId !== 'delivery')
      .map((p) => {
        return {
          amount: p.quantity,
          num: p.num,
          skuId: p.variantId,
        };
      });

    const body = {
      activated: true,
      columnType: 'HUMANID',
      comment: values.comment,
      correctionType: values.correctionType,
      items: updatedItems,
      warehouseId: values.warehouseIdChildren ? values.warehouseIdChildren : values.warehouseId,
    };

    const res = await dispatch(fetchPostSkuQtyCorrection(body));

    if (res.success) {
      toast.info(`Корректировка ${'#' + res.humanId || ''} успешно создана`);
      handleSwitchMode(CORRECTION_MODS.LIST);
    } else {
      toast.error(`Ошибка при создании корректировки
                ${res.errors ? `. ${res.errors[0].message}` : ``}    
         `);
    }
  };

  const handleWarehouseOptions = (warehouseId) => {
    if (!warehouseId) return;

    const warehouseByWarehouseId = warehouses.find((w) => w.code === warehouseId);

    if (warehouseByWarehouseId) {
      //We've found warehouse and set it's code:
      setFieldValue('warehouseId', warehouseByWarehouseId.code);
      return;
    } else {
      //If didn't - check for children warehouses inside main warehouse:
      let warehouseDataToSet = null;

      for (let w in warehouses) {
        if (warehouses[w].children) {
          for (let c in warehouses[w].children) {
            if (warehouseId === warehouses[w].children[c].code) {
              warehouseDataToSet = {
                warehouse: warehouses[w].code,
                children: warehouses[w].children[c].code,
              };
            }
          }
        }
      }

      if (warehouseDataToSet) {
        setFieldValue('warehouseId', warehouseDataToSet.warehouse);
        setFieldValue('warehouseIdChildren', warehouseDataToSet.children);
      }
    }
  };

  useEffect(() => {
    if ((mode === CORRECTION_MODS.INFO || mode === CORRECTION_MODS.EDIT) && correctionId) {
      const getCorrectionFullInfoById = async () => {
        try {
          const skuCorrections = await dispatch(
            fetchGetSkuQtyCorrection(`id=${correctionId}&full_info=true`),
          );
          setSkuCorrections(skuCorrections);

          handleCorrectionItemsToProductList(skuCorrections.skuQtyCorrectionDtoList[0].items);
          //TODO: Change to one call setValue({}) instead of setFieldValue()
          setFieldValue('comment', skuCorrections.skuQtyCorrectionDtoList[0]?.comment);
          setFieldValue('humanId', skuCorrections.skuQtyCorrectionDtoList[0]?.humanId);
          setFieldValue(
            'correctionType',
            skuCorrections.skuQtyCorrectionDtoList[0]?.correctionType,
          );
          setFieldValue('createTs', skuCorrections.skuQtyCorrectionDtoList[0]?.createTs);

          handleWarehouseOptions(skuCorrections.skuQtyCorrectionDtoList[0]?.warehouseId);

          setShowSpinner(false);
        } catch (error) {}
      };
      getCorrectionFullInfoById();
    }
  }, []);

  const [warehouseChildrenOptions, setWarehouseChildrenOptions] = useState();

  useEffect(() => {
    if (values.warehouseId) {
      const selectedWarehouse = warehouses.find((w) => w.code === values.warehouseId);
      if (selectedWarehouse?.children) {
        const childrenOptions = selectedWarehouse.children.map((item) => {
          return {
            value: item.goodsCondition,
            label: item.title,
            code: item.code,
          };
        });

        setWarehouseChildrenOptions(childrenOptions);
      } else {
        setWarehouseChildrenOptions(null);
      }
    }
  }, [values.warehouseId]);

  const handleEditCorrection = async () => {
    const updatedItems = products
      .filter((p) => p.variantId !== 'delivery')
      .map((p) => {
        return {
          amount: p.quantity,
          num: p.num,
          skuId: p.variantId,
          id: p.id,
          humanId: p.humanId,
        };
      });

    const body = {
      id: skuCorrections.skuQtyCorrectionDtoList[0].id,
      activated: true,
      columnType: 'HUMANID',
      comment: values.comment,
      correctionType: values.correctionType,
      items: updatedItems,
      warehouseId: values.warehouseIdChildren ? values.warehouseIdChildren : values.warehouseId,
    };

    const res = await dispatch(fetchPostSkuQtyCorrection(body));

    if (res.success) {
      toast.info(`Корректировка ${'#' + res.humanId || ''} успешно изменена`);
      handleSwitchMode(CORRECTION_MODS.LIST);
    } else {
      toast.error(`Ошибка при изменении корректировки
                ${res.errors ? `. ${res.errors[0].message}` : ``}    
         `);
    }
  };

  const handleAddItem = () => {
    const deliveryItem =
      products && products.length
        ? products.find((i) => i.variantId === 'delivery')
        : MOCK_DELIVERY_ITEM;

    dispatch(
      showModal('CorrectionAddingProducts', {
        currentProducts: products,
        currentWarehouse: null,
        needVariants: true,
        modalTitle: 'Добавить товар',
        buttonText: 'Сохранить товары',
        onProductsAdding: async (result) => {
          const resultCache = result.slice();
          const newItems = [];

          if (products.length > 0) {
            products.forEach((p) => {
              if (p.variantId !== 'delivery') {
                const findCurrentProductIndexInResultCache = resultCache.findIndex(
                  (i) => i.id === p.productId && i.variantId === p.variantId,
                );

                if (findCurrentProductIndexInResultCache === -1) {
                  newItems.push({ ...p, num: newItems.length + 1 });
                } else {
                  const findCurrentProduct = {
                    ...resultCache[findCurrentProductIndexInResultCache],
                  };
                  const currentVariant = findCurrentProduct.variants.find(
                    (v) => v.id === p.variantId,
                  );
                  if (findCurrentProduct.quantity) {
                    newItems.push({
                      num: newItems.length + 1,
                      variantId: findCurrentProduct.variantId,
                      productId: findCurrentProduct.id,
                      productExtId: findCurrentProduct.extId,
                      name: `${findCurrentProduct.shortName} ${
                        currentVariant?.optionsUsed
                          ? currentVariant.optionsUsed.map((o) => o.stringValue).join(' ')
                          : ''
                      }`,
                      quantity: findCurrentProduct.quantity,
                      price: p.price || currentVariant.price || 0,
                      img: currentVariant.defaultImage,
                      vatRate: p.vatRate || 'NO_VAT',
                      dimensions: currentVariant.dimensions,
                      weight: currentVariant.weight,
                      bundleOptionalVariants: findCurrentProduct.bundleOptionalVariants,
                    });
                  }
                  resultCache.splice(findCurrentProductIndexInResultCache, 1);
                }
              }
            });
          }

          if (resultCache.length) {
            resultCache.forEach((p) => {
              const currentVariant = p.variants.find((v) => v.id === p.variantId);
              if (p.quantity && currentVariant) {
                newItems.push({
                  num: newItems.length + 1,
                  variantId: p.variantId,
                  productId: p.id,
                  productExtId: p.extId,
                  name: `${p.shortName} ${
                    currentVariant?.optionsUsed
                      ? currentVariant.optionsUsed?.map((o) => o.stringValue).join(' ')
                      : ''
                  }`,
                  quantity: p.quantity,
                  price: currentVariant.price || 0,
                  img: currentVariant.defaultImage,
                  vatRate: currentVariant.vat || 'NO_VAT',
                  dimensions: currentVariant.dimensions,
                  weight: currentVariant.weight,
                  bundleOptionalVariants: p.bundleOptionalVariants,
                });
              }
            });
          }

          newItems.push({ ...deliveryItem, num: newItems.length + 1 });

          const filtredItems = newItems.filter((item) => item.name);
          setProducts(filtredItems);
        },
      }),
    );
  };

  const productRows =
    products.length > 0
      ? products?.map((product) => ({
          isRemovable: true,
          data: [
            {
              value:
                product.name !== 'Доставка' ? (
                  <p>
                    <span style={{ color: '#343a40', fontWeight: 700 }}>
                      {product.name || product.shortName}
                    </span>
                    <br />
                    <p>{product.variantId}</p>
                  </p>
                ) : null,
            },
            {
              value:
                product.name !== 'Доставка' ? (
                  <p className="text-center">{product.quantity}</p>
                ) : null,
            },
          ],
        }))
      : [];

  const warehousesOptions = warehouses?.map((w) => {
    return {
      label: w.title,
      value: w.code,
    };
  });

  const handleCorrectionItemsToProductList = (items) => {
    if (items.length === 0) {
      setShowSpinner(false);
      return;
    }

    const productsForTable = items.map((item) => {
      return {
        num: item.num,
        variantId: item.skuHumanId,
        productId: item.skuHumanId, //?
        productExtId: '',
        name: item.skuName,
        quantity: item.amount,
        price: null,
        vatRate: '',
        dimensions: {
          depth: null,
          height: null,
          width: null,
        },
        weight: null,
        id: item.id,
        humanId: item.humanId,
      };
    });

    setProducts(productsForTable);
    setShowSpinner(false);
  };

  return (
    <Wrapper>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <div style={{ marginBottom: '20px' }}>
            <Button
              type="submit"
              text="&#8592; Назад к списку корректировок"
              onClick={() => handleSwitchMode(CORRECTION_MODS.LIST)}
            />
            {mode === CORRECTION_MODS.ADD && (
              <Button
                text="Сохранить корректировку"
                style={{ marginLeft: '30px' }}
                onClick={() => handleCreateCorrection()}
              />
            )}
            {mode === CORRECTION_MODS.EDIT && (
              <Button
                text="Сохранить изменения"
                style={{ marginLeft: '30px' }}
                onClick={() => handleEditCorrection()}
              />
            )}
          </div>
          <div className="row">
            {mode !== CORRECTION_MODS.ADD ? (
              <>
                <div className="col-6">
                  <InputWrapper
                    label="Код"
                    id="humanId"
                    value={values.humanId}
                    onChange={(e) => handleChange('humanId', e.target.value)}
                    isDisabled={true}
                  />
                </div>
                <div className="col-6">
                  <label style={{ display: 'block' }}>Дата корректировки</label>
                  <DatePicker
                    id="createTs"
                    dateFormat="dd.MM.yyyy HH:mm"
                    showTimeSelect
                    selected={
                      values.createTs ? moment(values.createTs, `YYYY-MM-DD HH:mm`).toDate() : null
                    }
                    onChange={(date) =>
                      handleChange('createTs', moment(date).format(`YYYY-MM-DD HH:mm:ss`))
                    }
                    readOnly={true}
                  />
                </div>
              </>
            ) : null}
            <div className="col-12 mb-1 mt-1">
              <Select
                label="Тип корректировки"
                id="correctionType"
                options={CORRECTION_TYPE_OPTIONS}
                value={CORRECTION_TYPE_OPTIONS.find((o) => o.value === values.correctionType)}
                onChange={({ value }) => setFieldValue('correctionType', value)}
                isDisabled={mode === CORRECTION_MODS.INFO}
              />
            </div>
            <div className="col-6">
              <Select
                label="Склад"
                id="warehouseName"
                options={warehousesOptions}
                value={warehousesOptions.find((o) => o.value === values.warehouseId)}
                onChange={(option) => {
                  setFieldValue('warehouseId', option.value);
                  setFieldValue('warehouseIdChildren', null);
                }}
                isDisabled={mode === CORRECTION_MODS.INFO}
                isClearable={false}
              />
            </div>
            {warehouseChildrenOptions ? (
              <div className="warehouse-children col-6">
                <Select
                  label=" "
                  id="warehouseIdChildren"
                  options={warehouseChildrenOptions}
                  value={warehouseChildrenOptions.find(
                    (o) => o.code === values.warehouseIdChildren,
                  )}
                  onChange={(option) => {
                    setFieldValue('warehouseIdChildren', option.code);
                  }}
                  isDisabled={mode === CORRECTION_MODS.INFO}
                  isClearable={false}
                />
              </div>
            ) : null}
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              <TextArea
                label="Комментарий"
                id="comment"
                value={values.comment}
                onChange={(e) => setFieldValue('comment', e.target.value)}
                isDisabled={mode === CORRECTION_MODS.INFO}
              />
            </div>
          </div>
          <hr />
          {productRows.length > 0 ? (
            <>
              <h5 style={{ display: 'flex', alignItems: 'center' }}>Товар</h5>
              <Table
                data={{
                  cols: [`Товар`, `Количество`],
                  rows: productRows,
                }}
              />
            </>
          ) : (
            <SpinnerBlock show={showSpinner} className="mt-5" />
          )}
          {mode === CORRECTION_MODS.ADD || mode === CORRECTION_MODS.EDIT ? (
            <span style={{ cursor: 'pointer', color: '#7e57c3' }} onClick={handleAddItem}>
              Добавить / редактировать товары
            </span>
          ) : null}
        </div>
      </form>
    </Wrapper>
  );
};

export default Correction;
